import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { LoadingService } from '../../../core/services/loading/loading.service';


@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  imports: [CommonModule],
  standalone: true
})
export class LoadingComponent {
    loading$: Observable<boolean>;

    constructor(private loadingService: LoadingService) {

        this.loading$ = this.loadingService.loading$;
    }
}
